"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatOutputDate = exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.map.js");
var _formElements = require("@evidation/form-elements");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("./utils");
var _moment = _interopRequireDefault(require("moment"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactI18next = require("react-i18next");
var _LanguageContext = require("../contexts/LanguageContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var currentDate = new Date();
var currentYear = currentDate.getFullYear();
var DateSelect = _styledComponents["default"].select.withConfig({
  displayName: "datePicker__DateSelect"
})(["appearance:button;background:#fff;border-radius:0px;border:1px solid #e6e6e6;margin:0 0 8px 0;padding:2px 4px;font-size:1rem;"]);
var MonthSelect = (0, _styledComponents["default"])(DateSelect).withConfig({
  displayName: "datePicker__MonthSelect"
})(["width:50%;border-top-left-radius:3px;border-bottom-left-radius:3px;border-right:0;"]);
var DaySelect = (0, _styledComponents["default"])(DateSelect).withConfig({
  displayName: "datePicker__DaySelect"
})(["width:20%;"]);
var YearSelect = (0, _styledComponents["default"])(DateSelect).withConfig({
  displayName: "datePicker__YearSelect"
})(["width:30%;border-top-right-radius:3px;border-bottom-right-radius:3px;border-left:0;"]);
var Container = (0, _styledComponents["default"])(_formElements.InputLabel).withConfig({
  displayName: "datePicker__Container"
})(["display:block;padding-bottom:8px;"]);

// get number of days in the month
var daysInMonth = function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
};

// create array of days in the month
var getNumberOfDaysInMonth = function getNumberOfDaysInMonth() {
  var month = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var numDaysInMonth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : daysInMonth(month, year);
  var days = [];
  for (var i = 1; i <= numDaysInMonth; i++) {
    days.push(i);
  }
  return days;
};
var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var buildDate = function buildDate(_ref, dateFormat) {
  var _ref$month = _ref.month,
    month = _ref$month === void 0 ? undefined : _ref$month,
    _ref$day = _ref.day,
    day = _ref$day === void 0 ? undefined : _ref$day,
    _ref$year = _ref.year,
    year = _ref$year === void 0 ? undefined : _ref$year;
  switch (dateFormat) {
    case 'YYYY':
      if (_lodash["default"].isEmpty(year)) throw 'invalid date';
      // need to set the year here using setYear to get the right date w/ moment formatting
      var date = new Date();
      date.setYear("".concat(parseInt(year, 10)));
      return date;
    case 'YYYY-MM':
      if (_lodash["default"].isEmpty(year) || _lodash["default"].isEmpty(month)) throw 'invalid date';
      return new Date("".concat(parseInt(year, 10), "/").concat(parseInt(month, 10)));
    case 'YYYY-MM-DD':
    default:
      if (_lodash["default"].isEmpty(year) || _lodash["default"].isEmpty(month) || _lodash["default"].isEmpty(day)) throw 'invalid date';
      return new Date("".concat(parseInt(year, 10), "/").concat(parseInt(month, 10), "/").concat(parseInt(day, 10)));
  }
};
var formatOutputDate = exports.formatOutputDate = function formatOutputDate(date, dateFormat) {
  try {
    var newDate = buildDate(date, dateFormat);
    return (0, _moment["default"])(newDate).format(dateFormat);
  } catch (e) {
    return e;
  }
};

// valid if date is + 10yrs
var DatePicker = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(DatePicker, _PureComponent);
  var _super = _createSuper(DatePicker);
  function DatePicker(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, DatePicker);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getIncomingDate", function (value) {
      var parseValue = _this.props.parseValue;
      if (!_lodash["default"].isEmpty(value)) {
        var incomingDate = (0, _moment["default"])(parseValue(value));

        // making sure the date supplied is valid
        if (incomingDate.isValid()) {
          return {
            year: incomingDate.format("YYYY"),
            month: incomingDate.format("M"),
            day: incomingDate.format("D")
          };
        }
      }
      return {
        month: "",
        day: "",
        year: ""
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getYears", function () {
      var y = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var year = y === "" ? currentYear : y;
      var years = [year];
      for (var i = 1; i <= 100; i++) {
        years.push(years[years.length - 1] - 1);
      }
      return years;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "dateFormat", function () {
      return _this.props.config.dateFormat || _this.props.dateFormat;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (val, target) {
      var obj = (0, _defineProperty2["default"])({}, target, val);
      if ("month" === target) {
        // updating the number of days in the newly selected month
        obj.days = getNumberOfDaysInMonth(val, _this.state.year);
      } else if (target === "year") {
        // updating the number of days in month (covers the case of leap years)
        obj.days = getNumberOfDaysInMonth(_this.state.month, val);
      }
      _this.setState(obj, function () {
        var formattedDate = formatOutputDate(_this.state, _this.dateFormat());
        _this.props.input.onChange(formattedDate);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlur", function () {
      var formattedDate = formatOutputDate(_this.state, _this.dateFormat());
      _this.props.input.onBlur(formattedDate);
    });
    _this.state = _objectSpread(_objectSpread({
      years: _this.getYears(),
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      days: getNumberOfDaysInMonth()
    }, _this.getIncomingDate(props.input.value)), {}, {
      message: "",
      date: ""
    });
    return _this;
  }
  (0, _createClass2["default"])(DatePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _util_commonInputPara = (0, _utils.util_commonInputParamters)(this.props),
        labelStyle = _util_commonInputPara.labelStyle;
      var _this$state = this.state,
        month = _this$state.month,
        day = _this$state.day,
        year = _this$state.year,
        months = _this$state.months,
        days = _this$state.days,
        years = _this$state.years;
      var _this$props = this.props,
        _this$props$config = _this$props.config,
        _this$props$config$di = _this$props$config.disabled,
        disabled = _this$props$config$di === void 0 ? false : _this$props$config$di,
        _this$props$config$re = _this$props$config.required,
        required = _this$props$config$re === void 0 ? false : _this$props$config$re,
        label = _this$props.label,
        meta = _this$props.meta,
        onFocus = _this$props.input.onFocus,
        t = _this$props.t;
      return /*#__PURE__*/_react["default"].createElement(Container, {
        required: required,
        label: label,
        labelStyle: labelStyle
      }, _lodash["default"].includes(['YYYY-MM-DD', 'YYYY-MM'], this.dateFormat()) && /*#__PURE__*/_react["default"].createElement(MonthSelect, {
        className: "datepicker ".concat((0, _utils.constructFieldClassname)(meta)),
        id: "t-month",
        defaultValue: month,
        onChange: function onChange(e) {
          return _this2.handleChange(e.target.value, "month");
        },
        onFocus: onFocus,
        onBlur: this.onBlur,
        disabled: disabled
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: "",
        disabled: true
      }, "-", t('components.datePicker.month'), "-"), months.map(function (m) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: m,
          value: m
        }, t("common.months.".concat(monthNames[m - 1])));
      })), _lodash["default"].includes(['YYYY-MM-DD'], this.dateFormat()) && /*#__PURE__*/_react["default"].createElement(DaySelect, {
        className: "datepicker ".concat((0, _utils.constructFieldClassname)(meta)),
        id: "t-day",
        defaultValue: day,
        onChange: function onChange(e) {
          return _this2.handleChange(e.target.value, "day");
        },
        onFocus: onFocus,
        onBlur: this.onBlur,
        disabled: disabled
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: "",
        disabled: true
      }, "-", t('components.datePicker.day'), "-"), days.map(function (d) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: d,
          value: d
        }, d);
      })), /*#__PURE__*/_react["default"].createElement(YearSelect, {
        className: "datepicker ".concat((0, _utils.constructFieldClassname)(meta)),
        id: "t-year",
        defaultValue: year,
        onChange: function onChange(e) {
          return _this2.handleChange(e.target.value, "year");
        },
        onFocus: onFocus,
        onBlur: this.onBlur,
        disabled: disabled
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: "",
        disabled: true
      }, "-", t('components.datePicker.year'), "-"), years.map(function (y) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: y,
          value: y
        }, y);
      })));
    }
  }]);
  return DatePicker;
}(_react.PureComponent);
DatePicker.defaultProps = {
  dateFormat: 'YYYY-MM-DD',
  input: {},
  meta: {},
  config: {},
  parseValue: function parseValue(v) {
    return v;
  }
};
DatePicker.propTypes = {
  dateFormat: _propTypes["default"].oneOf(['YYYY-MM-DD', 'YYYY-MM', 'YYYY']),
  config: _propTypes["default"].shape({
    dateFormat: _propTypes["default"].oneOf(['YYYY-MM-DD', 'YYYY-MM', 'YYYY'])
  })
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)(_LanguageContext.curiousPandaNamespace)(DatePicker);